import { ButtonStateType, } from '@kubit/web-ui-components/button/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { ButtonVariantType } from '../variants';
const mainSectionHeaderGhostCommonStyles = (FOUNDATIONS) => ({
    gap: FOUNDATIONS.spacing_100,
    padding: '0',
    text_decoration: 'underline',
    color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
    font_weight: FONT_WEIGHT.font_bold,
    icon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
    },
});
export const getMainSectionHeaderGhostStyles = (FOUNDATIONS, FONT) => {
    return {
        [ButtonVariantType.MAIN_SECTION_HEADER_GHOST]: {
            [ButtonStateType.DEFAULT]: {
                ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS),
                gap: FOUNDATIONS.spacing_100,
                text_decoration: 'underline',
                color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
                font_weight: FONT_WEIGHT.font_bold,
                icon: {
                    ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                },
            },
            [ButtonStateType.HOVER]: {
                ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS),
                gap: FOUNDATIONS.spacing_100,
                text_decoration: 'none',
                color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
                font_weight: FONT_WEIGHT.font_bold,
                icon: {
                    ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                },
            },
            [ButtonStateType.PRESSED]: {
                ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS),
                gap: FOUNDATIONS.spacing_100,
                color: FOUNDATIONS.color_accent_pressed_secondary_font_250,
                text_decoration: 'underline',
                font_weight: FONT_WEIGHT.font_bold,
                icon: {
                    ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_accent_pressed_secondary_icon_250,
                },
            },
            [ButtonStateType.LOADING]: {
                background_color: FOUNDATIONS.color_contact_center_accent_loading_secondary_bg_50,
                cursor: 'not-allowed',
                pointer_events: 'none',
                border_width: FOUNDATIONS.border_50,
                border_color: FOUNDATIONS.color_contact_center_accent_loading_secondary_border_50,
                border_style: 'solid',
            },
            [ButtonStateType.DISABLED]: {
                ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS),
                color: FOUNDATIONS.color_accent_disabled_font_100,
                text_decoration: 'underline',
                gap: FOUNDATIONS.spacing_100,
                cursor: 'not-allowed',
                pointer_events: 'none',
                font_weight: FONT_WEIGHT.font_bold,
                icon: {
                    ...mainSectionHeaderGhostCommonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
        },
    };
};
//# sourceMappingURL=mainSectionHeaderGhost.js.map